import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import Layout from "../../layout/Main/Layout";
import { Button, Typography } from "@mui/material";
import { get, post, put } from "../../config/axios";
import toast from "react-hot-toast";

const EnrollDoctor = () => {
  const [doctors, setDoctors] = useState([]);

  // Fetch doctors on component mount
  const fetchDoctors = async () => {
    try {
      const data = await get("/api/dashboard/website/enroll-doctor");
      setDoctors(data);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  useEffect(() => {
    fetchDoctors();
  }, []);

  const handleUpdateDoctor = async (row) => {
    try {
      const response = await put(`/api/dashboard/website/enroll-doctor/${row._id}`, { isEnrolled: true });
      toast.success("Doctor updated successfully!");
      console.log("Updated Data:", response);
    } catch (error) {
      console.error("Error updating content:", error);
      toast.error("Failed to update content!");
    }
  };

  const handleEnroll = async (row) => {
    try {
      // formData.optInPersonConsultant = formData?.optInPersonConsultant === "YES";
      // // Convert empty string values to 0 for numeric fields
      // const numericFields = ["experience", "consultationFee", "processingFee"];
      // numericFields.forEach((field) => {
      //   if (formData[field] === "") {
      //     formData[field] = 0; // Replace empty string with null
      //   }
      // });
      const formData = {
        username: row.fullName,
        fullname: row.fullName,
        email: row.email,
        phone: row.phone,
        userType: "DOCTOR",
        password: "12345678"
      };

      const { ...data } = formData;
      console.log("payload:", data);
      const res = await post("/api/dashboard/dashUser/addAccount", data);

      if (!res || res.status === 400) {
        console.log("Error:", res)
        toast.error(res.message.message, "error");
      } else {
        toast.success(res.data.message, "success");
        await handleUpdateDoctor(row)
        fetchDoctors()
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Error while processing the request");
    }
  };

  const columns = [
    { field: "id", headerName: "S. No", width: 70 },
    { field: "fullName", headerName: "Full Name", width: 150 },
    { field: "specialization", headerName: "Specialization", width: 180 },
    { field: "email", headerName: "Email Address", width: 200 },
    { field: "phone", headerName: "Phone Number", width: 150 },
    { field: "clinic", headerName: "Clinic/Hospital Name", width: 200 },
    { field: "note", headerName: "Additional Note", width: 250 },
    {
      field: "action",
      headerName: "Enroll",
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEnroll(params.row)}
          disabled={params.row.isEnrolled} // Disables button if isEnrolled is true
        >
          Enroll
        </Button>
      ),
    },
  ];

  const paginationModel = { page: 0, pageSize: 5 };

  return (
    <Layout>
      <div style={{ padding: '1rem' }}>
        <Typography variant="h5" paddingY={2}>Doctor Enrollment Requests</Typography>
        <Paper sx={{ width: '100%' }}>
          <DataGrid
            rows={doctors?.map((doctor, index) => ({ id: index + 1, ...doctor }))}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10]}
            sx={{
              border: 0,
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
              },
            }}
          />
        </Paper>
      </div>
    </Layout>
  );
};

export default EnrollDoctor;
